import {CountryStateEffects} from './country-state.effects';
import {SeatmapEffects} from '@ibe/store/effects/seatmap.effects';

/** CountryState */
const countryStateEffects = [
	CountryStateEffects
];

/**
 * Seatmap
 */
const seatmapEffects = [
	SeatmapEffects
];

export const allEffects = [
	...countryStateEffects,
	...seatmapEffects
];
